import { z } from "zod";
/** Scope changes presentation only. The kiosk's start node remains its origin. */
export const interactiveHomeScopeSchema = z.enum(["floor", "building", "campus"]);
export const INTERACTIVE_HOME_IDLE_TIMEOUT_SECONDS = 60;
export const interactiveKioskHomeSettingsSchema = z.object({
    scope: interactiveHomeScopeSchema,
    /** Total inactivity before screensaver; null keeps the interactive Home up. */
    screensaverAfterSeconds: z.number().int().min(INTERACTIVE_HOME_IDLE_TIMEOUT_SECONDS + 1).max(86_400).nullable(),
    showAxiosBranding: z.boolean(),
}).strict();
export const interactiveHomeConfigurationSchema = z.object({
    screens: z.array(interactiveKioskHomeSettingsSchema.extend({
        screenId: z.string().uuid(),
    }).strict()).min(1).max(10_000),
}).strict().refine((value) => new Set(value.screens.map((screen) => screen.screenId)).size === value.screens.length, "Each screen must have exactly one Home configuration");
//# sourceMappingURL=home-presentation.js.map